/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiCustomListRecord,
    InternalApiCustomListRecordFromJSON,
    InternalApiCustomListRecordToJSON,
    InternalApiCustomListRecordPage,
    InternalApiCustomListRecordPageFromJSON,
    InternalApiCustomListRecordPageToJSON,
} from '../models';

export interface AddRecordRequest {
    customListId: string;
    internalApiCustomListRecord: InternalApiCustomListRecord;
}

export interface DeleteRecordRequest {
    customListId: string;
    id: string;
}

export interface DownloadRecordsRequest {
    customListId: string;
}

export interface DownloadRecordsResponse {
    headers: Headers;
    body: Blob;
}

export interface GetRecordRequest {
    customListId: string;
    id: string;
}

export interface GetRecordsRequest {
    customListId: string;
    page: number;
    size: number;
    searchArchived?: boolean;
    query?: string;
}

export interface UpdateRecordRequest {
    customListId: string;
    id: string;
    internalApiCustomListRecord: InternalApiCustomListRecord;
}

/**
 * 
 */
export class CustomListRecordInternalApi extends runtime.BaseAPI {

    /**
     * Creates new record in the custom list
     */
    async addRecordRaw(requestParameters: AddRecordRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCustomListRecord>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling addRecord.');
        }

        if (requestParameters.internalApiCustomListRecord === null || requestParameters.internalApiCustomListRecord === undefined) {
            throw new runtime.RequiredError('internalApiCustomListRecord','Required parameter requestParameters.internalApiCustomListRecord was null or undefined when calling addRecord.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/{customListId}/records`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiCustomListRecordToJSON(requestParameters.internalApiCustomListRecord),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCustomListRecordFromJSON(jsonValue));
    }

    /**
     * Creates new record in the custom list
     */
    async addRecord(requestParameters: AddRecordRequest, initOverrides?: RequestInit): Promise<InternalApiCustomListRecord> {
        const response = await this.addRecordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes record in the custom list
     */
    async deleteRecordRaw(requestParameters: DeleteRecordRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling deleteRecord.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteRecord.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/{customListId}/records/{id}`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes record in the custom list
     */
    async deleteRecord(requestParameters: DeleteRecordRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteRecordRaw(requestParameters, initOverrides);
    }

    /**
     * Download all custom list records as CSV
     */
    async downloadRecordsRaw(requestParameters: DownloadRecordsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling downloadRecords.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/{customListId}/records/external-ids`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download all custom list records as CSV
     */
    async downloadRecords(requestParameters: DownloadRecordsRequest, initOverrides?: RequestInit): Promise<DownloadRecordsResponse> {
        const response = await this.downloadRecordsRaw(requestParameters, initOverrides);
        return {
          headers: response.raw.headers,
          body: await response.value(),
        };
    }

    /**
     * Get single Record
     */
    async getRecordRaw(requestParameters: GetRecordRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCustomListRecord>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling getRecord.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getRecord.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/{customListId}/records/{id}`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCustomListRecordFromJSON(jsonValue));
    }

    /**
     * Get single Record
     */
    async getRecord(requestParameters: GetRecordRequest, initOverrides?: RequestInit): Promise<InternalApiCustomListRecord> {
        const response = await this.getRecordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get custom list records
     */
    async getRecordsRaw(requestParameters: GetRecordsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCustomListRecordPage>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling getRecords.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling getRecords.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling getRecords.');
        }

        const queryParameters: any = {};

        if (requestParameters.searchArchived !== undefined) {
            queryParameters['searchArchived'] = requestParameters.searchArchived;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/{customListId}/records`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCustomListRecordPageFromJSON(jsonValue));
    }

    /**
     * Get custom list records
     */
    async getRecords(requestParameters: GetRecordsRequest, initOverrides?: RequestInit): Promise<InternalApiCustomListRecordPage> {
        const response = await this.getRecordsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates custom list record in the list
     */
    async updateRecordRaw(requestParameters: UpdateRecordRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiCustomListRecord>> {
        if (requestParameters.customListId === null || requestParameters.customListId === undefined) {
            throw new runtime.RequiredError('customListId','Required parameter requestParameters.customListId was null or undefined when calling updateRecord.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateRecord.');
        }

        if (requestParameters.internalApiCustomListRecord === null || requestParameters.internalApiCustomListRecord === undefined) {
            throw new runtime.RequiredError('internalApiCustomListRecord','Required parameter requestParameters.internalApiCustomListRecord was null or undefined when calling updateRecord.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/custom-lists/{customListId}/records/{id}`.replace(`{${"customListId"}}`, encodeURIComponent(String(requestParameters.customListId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiCustomListRecordToJSON(requestParameters.internalApiCustomListRecord),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiCustomListRecordFromJSON(jsonValue));
    }

    /**
     * Updates custom list record in the list
     */
    async updateRecord(requestParameters: UpdateRecordRequest, initOverrides?: RequestInit): Promise<InternalApiCustomListRecord> {
        const response = await this.updateRecordRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
